import React, { ReactNode, useEffect } from 'react';

import { Link } from 'react-router-dom';

import _noop from 'lodash/noop';

type Props = {
  className?: string;
  isExternalLink?: boolean;
  onClick?: () => void;
  onMount?: () => void;
  openInNewTab?: boolean;
  specificLocators?: string;
  to: string;
  children: ReactNode;
};

const LinkWrapper = ({
  children,
  className,
  isExternalLink = false,
  onClick = _noop,
  onMount = _noop,
  openInNewTab = false,
  specificLocators,
  to,
}: Props) => {
  useEffect(() => {
    onMount();
  }, []);

  const commonProps = {
    'data-locator': specificLocators,
    className,
    onClick,
    rel: 'noopener noreferrer',
    target: openInNewTab ? '_blank' : '_self',
  };

  return isExternalLink ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <a {...commonProps} href={to}>
      {children}
    </a>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link {...commonProps} to={to}>
      {children}
    </Link>
  );
};

export default LinkWrapper;
